import { defer, finalize, Observable } from 'rxjs';

export function toPayload<T>(action: { payload: T }): T {
  return action.payload;
}

export function onSubscribe<T>(onCountUpdate: (count: number) => void = () => {}) {
  return function refCountOperatorFunction(source$: Observable<T>) {
    let counter = 0;

    return defer(() => {
      counter++;
      onCountUpdate(counter);
      return source$;
    }).pipe(
      finalize(() => {
        counter--;
        onCountUpdate(counter);
      }),
    );
  };
}
